var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.2396C0 11.1863 2.88 10.669 6.26087 10.669C9.64174 10.669 12.5217 11.2022 12.5217 13.2555C12.5217 15.3088 9.64174 15.8261 6.26087 15.8261C2.88 15.8261 0 15.2929 0 13.2396ZM2.12033 4.70805C2.03773 4.14886 2.08093 3.5793 2.24704 3.03725C2.41316 2.49519 2.69838 1.99306 3.08376 1.56421C3.46915 1.13536 3.94586 0.789614 4.48222 0.54997C5.01858 0.310326 5.6023 0.182285 6.19458 0.174316C6.78686 0.166347 7.37415 0.278633 7.91739 0.503751C8.46063 0.728869 8.94737 1.06165 9.34529 1.47996C9.74322 1.89827 10.0432 2.39255 10.2253 2.92992C10.4074 3.46729 10.4674 4.03545 10.4014 4.59665V4.70805C10.2881 5.67092 9.81029 6.56132 9.05747 7.21221C8.30465 7.8631 7.32858 8.22978 6.31238 8.24346C5.29618 8.25713 4.30968 7.91686 3.53789 7.28648C2.7661 6.6561 2.26205 5.77892 2.12033 4.81948V4.70805Z",
    fill: "#778797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8779 3.58405L12.8779 3.58405C9.71781 2.98045 6.98047 5.71779 7.58407 8.87784L7.58407 8.87785C7.92296 10.6518 9.34862 12.0775 11.1226 12.4164C14.2827 13.02 17.02 10.2826 16.4164 7.1226L15.9253 7.2164L16.4164 7.12259C16.0775 5.34859 14.6519 3.92292 12.8779 3.58405Z",
    fill: "#778797",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePending);
export default __webpack_public_path__ + "static/media/profile_pending.0cf993a3af4a40002838b0ab7f96d155.svg";
export { ForwardRef as ReactComponent };